import {Box, CloseIcon, styled, Button, Fab, ArrowBackIosIcon, ArrowForwardIosIcon, Modal} from '../../../ui-library';

export const ModalBox = styled(Modal)`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    margin-bottom: 50px;
    border: transparent;
`;

export const ImageBox = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 5px 0;
    width: 100%;
    height: calc(100vh - 10px);
    border-radius: 10px;
    overflow: hidden;
`;


export const GalleryBox = styled(Box)`
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding-left: 37px;
    padding-right: 37px;
    user-focus-pointer: none;
`;

export const ExitIcon = styled(CloseIcon)`
    display: flex;
    position: absolute;
    font-size: 24px;
    cursor: pointer;
    color: #FFFFFF;
    margin-left: 37px;
    margin-top: 37px;
`;


export const DeleteButton = styled(Button)`
    ${({ theme }) => theme.typography.button};
    color: #FFFFFF;
    border-color: #FFFFFF;
    width: 108px;
    font-size: 14px;
    height: 36px;
    align-items: center;
    text-transform: uppercase;
    margin-bottom: 15px;
    &:hover {
        border-color: #FFFFFF;
    }
`;

const FabBtn = styled(Fab)`
    width: 48px;
    height: 48px;
    color: #FFFFFF;
    position: fixed;
    top:50%;
    background-color:${({ theme }) => theme.palette.grey[600]};
    &:hover {
        background-color: ${({ theme }) => theme.palette.grey[500]};
    }
    &:disabled {
        color: ${({ theme }) => theme.palette.grey[600]};
        background-color: ${({ theme }) => theme.palette.grey[500]};
    }
    &:focus {
        background-color: ${({ theme }) => theme.palette.grey[800]};
    }
`;

export const FabBtnLeft = styled(FabBtn)`
    left: 20px;
`;

export const FabBtnRight = styled(FabBtn)`
    right: 20px;
`;


export const ArrowBackIcon = styled(ArrowBackIosIcon)`
    font-size: 14px;
    margin-left: 5px;
`;

export const ArrowForwardIcon = styled(ArrowForwardIosIcon)`
    font-size: 14px;
`;


export const StyledImg = styled('img')`
    border-radius: 10px;
    user-select: none;
    height: 90%;
    object-fit: contain;
    margin: 5px;
`;
